import { User } from "react-feather";
import "./LatestArticleRow.css";

export const LatestArticleRow = (props) => {
    const author = props.item.author || props.item.createUser;
    return (
        <>
            <div className="search-result-row" key={`article-${props.item.id}`}>
                <div
                    className="search-results-row desc"
                >
                    <div className="link" onClick={() => props.onClick(props.item)}>
                        {props.item.name}
                    </div>
                    <div className="search-results-row article-info">
                        {"from " + author} <User size={16} /> {props.item.views}
                    </div>
                </div>

                {props.config.PUBLISH_ENABLED && (
                    <div
                        className="search-results-item-publish btn btn-primary"
                        onClick={() => {
                            props.setPublishItem(props.item);
                        }}
                    >
                        Publish
                    </div>
                )}
            </div>
        </>
    );
};
